var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caseAllList"},[_c('Personal-center-head',[_c('div',[_vm._v("我的病例")]),_c('template',{slot:"revert"},[_c('div',{staticClass:"revert"},[_vm._v("返回")])])],2),_c('div',{staticClass:"caseAllList-content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }